import { render } from "./index.vue?vue&type=template&id=b098a9cc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=b098a9cc&lang=less&scoped=true"

import exportComponent from "G:\\website\\work\\xmjh\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b098a9cc"]])

export default __exports__